export const COUNTERS_LIST_REQUEST = 'COUNTERS_LIST_REQUEST'
export const COUNTERS_UPDATED = 'COUNTERS_UPDATED'
